import { Icon } from '@mui/material';
import MDButton from 'components/MDButton';

export default function BranchTable() {


    const formBranchRows = (data, editBranch) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                location: dt.location,
                address: dt.address,
                manager: dt.manager.username,
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { editBranch(dt) }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result;
    };

    const formUserRows = (data) => {
        let result = [];
        for (let dt of data) {
            result.push({
                username: dt.username,
                role: dt.role.name
            });
        }
        return result;
    };

    return {
        formBranchRows,
        formUserRows,
        branchHeaders: [
            { Header: "BRANCH NAME", accessor: "name", align: "center" },
            { Header: "Location", accessor: "location", align: "center" },
            { Header: "Address", accessor: "address", align: "center" },
            { Header: "Manager", accessor: "manager", align: "center" },
            { Header: "Edit", accessor: "action", align: "center" }
        ],
        userHeaders: [
            { Header: "Username", accessor: "username", align: "center" },
            { Header: "Role", accessor: "role", align: "center" }
        ],
    };
}
